import api from "../../api/api";
import { getClientDetails } from './auth';
import * as routePaths from '../../constants/routePaths';
import moment from 'moment';

export const GET_PASTCASELIST = 'GET_PASTCASELIST';
export const GET_CURRENTCASELIST = 'GET_CURRENTCASELIST';
export const GET_INVENTORYLIST = 'GET_INVENTORYLIST';
export const GET_WORKFLOWCASEDETAILS = 'GET_WORKFLOWCASEDETAILS';
export const GET_ACTIVESTAGENAME = 'GET_ACTIVESTAGENAME';
export const SET_LOADING = 'SET_LOADING';
export const GE_ACTIVECASEID = 'GE_ACTIVECASEID';
export const GE_RELOCATIONPLANDETAILS = 'GE_RELOCATIONPLANDETAILS';
export const GET_INVENTORYROOMS = 'GET_INVENTORYROOMS';
export const GET_LOCATIONLIST = 'GET_LOCATIONLIST';
export const GET_UNITLISTT = 'GET_UNITLISTT';
export const GET_ADMINUNITLIST = 'GET_ADMINUNITLIST';
export const GET_SERVICELIST = 'GET_SERVICELIST';
export const GET_TENURELIST = 'GET_TENURELIST';
export const GET_CONTACTDETAILS = 'GET_CONTACTDETAILS';
export const SAVE_RELOCATIONPLANID = 'SAVE_RELOCATIONPLANID';
export const SAVE_ITEMS = 'SAVE_ITEMS';
export const GET_RELOCATIONDETAILSVIEW = 'GET_RELOCATIONDETAILSVIEW';
export const GET_DEPTITEMS = 'GET_DEPTITEMS';
export const SAVE_CASEID = 'SAVE_CASEID';
export const GE_SAVEACTIVECASEID = 'GE_SAVEACTIVECASEID';
export const SAVERESERVE = 'SAVERESERVE';
export const SAVEFOREIGNDEFENSE = 'SAVEFOREIGNDEFENSE';
export const UPDATE_INVENTORYLIST = 'UPDATE_INVENTORYLIST';

export function getcontactDetails(contactDetails) {
    return {
        type: GET_CONTACTDETAILS,
        contactDetails: contactDetails
    }
}

export function getPastCaseList(pastCaseList) {
    return {
        type: GET_PASTCASELIST,
        pastCaseList: pastCaseList
    }
}

export function getCurrentCaseList(currentCaseList) {
    return {
        type: GET_CURRENTCASELIST,
        currentCaseList: currentCaseList
    }
}

export function getInventoryList(inventoryList) {
    return {
        type: GET_INVENTORYLIST,
        inventoryList: inventoryList
    }
}

export function updateInventoryList(updatedRoom) {
    return {
        type: UPDATE_INVENTORYLIST,
        updatedRoom: updatedRoom
    }
}

export function getWorkFlowCaseDetails(workFlowCaseDetails) {
    return {
        type: GET_WORKFLOWCASEDETAILS,
        workFlowCaseDetails: workFlowCaseDetails
    }
}
export function getActiveStageName(activeStageName) {
    return {
        type: GET_ACTIVESTAGENAME,
        activeStageName: activeStageName
    }
}
export function setLoading(loading) {
    return {
        type: SET_LOADING,
        loading: loading
    }
}
export function getActiveCaseId(activeCaseId) {
    return {
        type: GE_ACTIVECASEID,
        activeCaseId: activeCaseId
    }
}
export function saveActiveCaseId(activeCaseId) {
    return {
        type: GE_SAVEACTIVECASEID,
        activeCaseId: activeCaseId
    }
}
export function saveReserve(data) {
    return {
        type: SAVERESERVE,
        data: data
    }
}
export function saveForeignDefense(data) {
    return {
        type: SAVEFOREIGNDEFENSE,
        data: data
    }
}

export function getRelocationPlanDetails(relocationPlanDetails) {
    return {
        type: GE_RELOCATIONPLANDETAILS,
        relocationPlanDetails: relocationPlanDetails
    }
}
export function getInventoryRooms(inventoryRooms) {
    return {
        type: GET_INVENTORYROOMS,
        inventoryRooms: inventoryRooms
    }
}
export function getRelocationDetailsView(state) {
    return {
        type: GET_RELOCATIONDETAILSVIEW,
        state: state
    }
}

export function getUnitList(unitList) {
    return {
        type: GET_UNITLISTT,
        unitList: unitList
    }
}
export function getAdminUnitList(adminUnitList) {
    return {
        type: GET_ADMINUNITLIST,
        adminUnitList: adminUnitList
    }
}
export function getServiceList(serviceList) {
    return {
        type: GET_SERVICELIST,
        serviceList: serviceList
    }
}
export function getTenureList(tenureList) {
    return {
        type: GET_TENURELIST,
        tenureList: tenureList
    }
}
export function saveRelocationPlanId(id) {
    return {
        type: SAVE_RELOCATIONPLANID,
        data: id
    }
}

export function saveNewRoom(newRoom) {
    return {
        type: SAVE_ITEMS,
        newRoom: newRoom
    }
}

export function getDeptItems(deptItems) {
    return {
        type: GET_DEPTITEMS,
        deptItems: deptItems
    }
}
export function saveCaseId(caseId) {
    return {
        type: SAVE_CASEID,
        data: caseId
    }
}

//Index all api
export function index(id, history) {
    return dispatch => {
        if (id === "0") {
            id = "";
        }

        // if(sessionStorage.getItem("transfereeId")!==null && sessionStorage.getItem("transfereeId")!==""){

        // }else{
        dispatch(getRetrieveTransfereeIdForCurrentUser(history, id));
        dispatch(setLoading(true));
        // }
    };
}

// get userDetail from api 
export function getRetrieveTransfereeIdForCurrentUser(history, id) {
    const url = `api/TransfereeDetailService/RetrieveTransfereeIdForCurrentUser`;
    return dispatch => {
        // get TransfereeDetail from api
        return api.request(url, 'get').then(response => {
            if (response.Successful) {
                sessionStorage.setItem("transfereeId", response.UserDetails.PartyId);
                let Details = new Promise((resolve, reject) => {
                    const partyId = { "id": response.UserDetails.PartyId }
                    const urls = `api/TransfereeDetailService/RetrieveTransfereeGeneralDetails`;
                    api.request(urls, 'post', partyId).then(response => {
                        /*** This need to be replaced in relocation details **/
                        let dependantIDs = "";
                        if (sessionStorage.getItem("DependantIDs") === null) {
                            response.TransfereeDetails.DependantIDs.forEach(dependant => {
                                dependantIDs += dependant.IndividualPartyId.toString() + ", ";
                            })

                        }
                        if (dependantIDs !== null && dependantIDs.toString() !== "")
                            sessionStorage.setItem("DependantIDs", dependantIDs.substring(0, dependantIDs.length - 2));
                        sessionStorage.setItem("clientId", response.TransfereeDetails.ClientId);
                        //IsClientTypeAsDefence element is False Redirect to Login page
                        if (response.TransfereeDetails.IsClientTypeAsDefence === true) {
                            const clientId = response.TransfereeDetails.ClientId;
                            dispatch(getcontactDetails(response.TransfereeDetails));
                            dispatch(getRetrieveClientProfile(clientId));
                            resolve("forword");
                        } else {
                            reject("goback");
                        }
                    }, err => {
                    });
                })
                Details.then(result => {
                    dispatch(getRetrieveUnUsedInventoryDetailsByPartyId(response.UserDetails.PartyId));
                    dispatch(getCaseSummary(response.UserDetails.PartyId, id));
                }).catch((result) => {
                    history.push(routePaths.INDEX);
                })
            } else {

            }
        });
    }
}

// get ClientDetails from api
export function getRetrieveClientProfile(clientID) {
    const id = { "Id": clientID }
    const url = `api/ClientDetailService/RetrieveClientProfile`;
    return dispatch => {
        return api.request(url, 'post', id).then(response => {
            dispatch(getClientDetails(response.ClientDetails))
        }, err => {
        });
    }
}

// get CaseSummary from api
export function getCaseSummary(transfereeId, id) {
    const currentCaseList = [];
    const pastCaseList = [];
    //const caseSummary = {"CurrentCaseList" : CurrentCaseList , "PastCaseList" : PastCaseList};
    const url = `api/Transferee/${transfereeId}/CaseSummary`;
    const urlB = `api/OrderDetailService/RetrieveRelocationPlanRemovalDetails`;
    return dispatch => {
        api.request(url, 'get').then(response => {
            if (response.Successful) {
                if (response.Cases.length > 0) {
                    let count1 = 0;
                    let count3 = 0;
                    response.Cases.forEach(a => {
                        const Inventories = [];
                        const RelocationPlan = { "RelocationPlanId": '', "Inventories": Inventories };
                        const caseDetail = {
                            "IsRequestReimbursmentApplicable": '', "CaseNumber": '', "CaseId": '',
                            "CaseStatusId": '', "CaseStatusCode": '', "CaseManager": '', "RelocationPlan": RelocationPlan, "NoticeId": ''
                        };
                        if (a.IsRequestReimbursmentApplicable !== null && a.IsRequestReimbursmentApplicable !== "") {
                            caseDetail.IsRequestReimbursmentApplicable = a.IsRequestReimbursmentApplicable;
                        } else {
                            caseDetail.IsRequestReimbursmentApplicable = false;
                        }
                        if (a.CaseId !== null && a.CaseId !== "") {
                            caseDetail.CaseId = a.CaseId;
                            if (id === null || id === "" || id === "1")
                                id = a.CaseId;
                        }
                        if (a.CaseNumber !== null && a.CaseNumber !== "") {
                            caseDetail.CaseNumber = a.CaseNumber;
                            if (id !== null && id !== "" && id !== "1") {
                                if (caseDetail.CaseId === parseInt(id)) {
                                    sessionStorage.setItem("CaseNumber", a.CaseNumber);
                                    sessionStorage.setItem("CaseId", caseDetail.CaseId);
                                }
                            }
                        }
                        caseDetail.CaseNumber = a.CaseNumber;
                        caseDetail.CaseStatusId = a.CaseStatusId;
                        caseDetail.CaseManager = a.CaseManager;
                        caseDetail.CaseStatusCode = a.CaseStatusCode;
                        caseDetail.Notices = a.Notices;
                        if (a.RelocationPlan !== null && a.RelocationPlan !== "") {
                            if (a.RelocationPlan.RelocationPlanId !== null && a.RelocationPlan.RelocationPlanId !== '') {
                                caseDetail.RelocationPlan.RelocationPlanId = a.RelocationPlan.RelocationPlanId;
                                if (id !== null && id !== "" && id !== "1") {
                                    if (caseDetail.CaseId === parseInt(id)) {
                                        sessionStorage.setItem("RelocationPlanId", a.RelocationPlan.RelocationPlanId);
                                        sessionStorage.setItem("CaseId", caseDetail.CaseId);
                                    }

                                }
                            }
                        } else if (a.RelocationPlan === null) {
                            a.RelocationPlan = {
                                Inventories: []
                            }
                        }

                        const sList = [];
                        let count2 = 0;
                        if (a.RelocationPlan !== null && a.CaseId !== null && a.CaseId !== "") {
                            if (a.RelocationPlan.Inventories !== null && a.RelocationPlan.Inventories.length !== 0) {

                                const relocationSummary = () => {
                                    return new Promise((resolve) => {
                                        const urlR = `api/Order/${a.CaseId}/RetrieveRelocationPlanServiceSummary`;
                                        api.request(urlR, 'get').then(response => {
                                            resolve(response.RelocationPlanServiceSummary);
                                        });
                                    })
                                }
                                Promise.all([relocationSummary()]).then(serviceList => {
                                    a.RelocationPlan.Inventories.forEach(i => {
                                        const inventory = {
                                            "RelocationPlanServiceList": '', "InveFntoryName": '', "InventoryId": '',
                                            "RelocationPlanServiceId": '', "Status": '', "PurchaseOrderNumber": '',
                                            "ToAddress": {}, "FromAddress": {}
                                        }
                                        if (i.InventoryId !== null && i.InventoryId !== "")
                                            inventory.InventoryId = i.InventoryId;

                                        if (i.RelocationPlanServiceId !== null && i.RelocationPlanServiceId !== "") {

                                            inventory.InventoryName = i.InventoryName;

                                            inventory.RelocationPlanServiceId = i.RelocationPlanServiceId;
                                            inventory.Status = i.Status;
                                            inventory.PurchaseOrderNumber = i.PurchaseOrderNumber;
                                            serviceList.forEach(s => {
                                                if (i.RelocationPlanServiceId === s.RelocationPlanServiceID) {
                                                    sList.push(i);
                                                }
                                            });
                                            const RPlanSList = {
                                                "RelocationPlanServiceID": '', "RelocationPlanServiceStatusDescription": '',
                                                "IsAddReport": '', "ServiceDescription": '', "ServiceType": "REMOVAL", "IsRemoval": '', "FromAddress": "",
                                                "ServiceCode": '', "prepackDate": '', "CaseServiceField3": '', "ToAddress": ""
                                            };

                                            if (i.InventoryName !== "" && i.InventoryId !== "" && i.RelocationPlanServiceId !== "") {
                                                if (i.RelocationPlanServiceId !== null && i.RelocationPlanServiceId !== "") {
                                                    const ReRPlan = { "RelocationPlanServiceID": i.RelocationPlanServiceId, "PartyID": transfereeId, "CaseID": a.CaseId, "Id": i.InventoryId }
                                                    const relocationDetails = () => {
                                                        return new Promise(resolve => {
                                                            api.request(urlB, 'post', ReRPlan).then(
                                                                response => resolve(response.RelocationPlanServiceDetails));
                                                        })
                                                    };
                                                    Promise.all([relocationDetails()]).then(reDetails => {
                                                        const move = reDetails[0].Move;
                                                        RPlanSList.RelocationPlanServiceID = i.RelocationPlanServiceId;
                                                        RPlanSList.RelocationPlanServiceStatusDescription = reDetails[0].RelocationPlanServiceStatusDescription;
                                                        RPlanSList.ServiceDescription = reDetails[0].ServiceProductDescription;

                                                        RPlanSList.ServiceCode = reDetails[0].ProductCode;
                                                        RPlanSList.IsAddReport = false;
                                                        if (reDetails[0].RelocationPlanServiceStatusID !== null && reDetails[0].RelocationPlanServiceStatusID !== "") {
                                                            RPlanSList.RelocationPlanServiceStatusID = reDetails[0].RelocationPlanServiceStatusID;
                                                        }
                                                        RPlanSList.ServiceType = "REMOVAL";
                                                        // tricky using field "CaseServiceField3" which looks like a helper field in Move Maestro
                                                        RPlanSList.IsRemoval = RPlanSList.ServiceType === "REMOVAL"; // Hardcode?

                                                        if (reDetails[0].ServiceProductDescription.toUpperCase().indexOf("PET") !== -1) {
                                                            RPlanSList.CaseServiceField3 = "";
                                                            inventory.InventoryName = i.InventoryName;

                                                            if (reDetails[0].MovePet !== null && reDetails[0].MovePet !== "") {
                                                                const movePet = reDetails[0].MovePet;
                                                                if (sList.length > 0) {
                                                                    if (sList[0].PrePackDate !== undefined && sList[0].PrePackDate !== undefined && sList[0].PrePackDate !== null && sList[0].PrePackDate !== "") {
                                                                        RPlanSList.prepackDate = sList[0].PrePackDate;
                                                                    } else {
                                                                        RPlanSList.prepackDate = movePet.UpliftDate;
                                                                    }
                                                                } else {
                                                                    RPlanSList.prepackDate = movePet.UpliftDate;
                                                                }

                                                                if (movePet.UpliftProperties[0].PropertyAddress !== null && movePet.UpliftProperties[0].PropertyAddress !== "") {
                                                                    if (movePet.UpliftProperties[0].PropertyAddress.StreetAddressCity !== null && movePet.UpliftProperties[0].PropertyAddress.StreetAddressCity !== "") {
                                                                        RPlanSList.FromAddress = movePet.UpliftProperties[0].PropertyAddress.StreetAddressCity;
                                                                    }
                                                                }
                                                                if (movePet.DeliveryProperties[0].PropertyAddress !== null && movePet.DeliveryProperties[0].PropertyAddress !== "") {
                                                                    if (movePet.DeliveryProperties[0].PropertyAddress.StreetAddressCity !== null && movePet.DeliveryProperties[0].PropertyAddress.StreetAddressCity !== "") {
                                                                        RPlanSList.ToAddress = movePet.DeliveryProperties[0].PropertyAddress.StreetAddressCity;
                                                                    }
                                                                }
                                                            } else {
                                                                if (move !== null && move !== "") {
                                                                    if (sList.length > 0) {
                                                                        if (sList[0].PrePackDate !== undefined && sList[0].PrePackDate !== null && sList[0].PrePackDate !== "") {
                                                                            RPlanSList.prepackDate = sList[0].PrePackDate;
                                                                        } else {
                                                                            RPlanSList.prepackDate = move.UpliftDate;
                                                                        }
                                                                    } else {
                                                                        RPlanSList.prepackDate = move.UpliftDate;
                                                                    }
                                                                }
                                                                if (move.UpliftProperties[0].PropertyAddress !== null && move.UpliftProperties[0].PropertyAddress !== "") {

                                                                    if (move.UpliftProperties[0].PropertyAddress.StreetAddressCity !== null && move.UpliftProperties[0].PropertyAddress.StreetAddressCity !== "") {
                                                                        RPlanSList.FromAddress = move.UpliftProperties[0].PropertyAddress.StreetAddressCity;
                                                                    }
                                                                }
                                                                if (move.DeliveryProperties[0].PropertyAddress !== null && move.DeliveryProperties[0].PropertyAddress !== "") {

                                                                    if (move.DeliveryProperties[0].PropertyAddress.StreetAddressCity !== null && move.DeliveryProperties[0].PropertyAddress.StreetAddressCity !== "") {
                                                                        RPlanSList.ToAddress = move.DeliveryProperties[0].PropertyAddress.StreetAddressCity;
                                                                    }
                                                                }
                                                            }
                                                            const crurrebtDate = new Date();
                                                            if (moment(inventory.PrePackDate).format('MM/DD/YYYY') <= crurrebtDate.toLocaleDateString()) {
                                                                RPlanSList.IsAddReport = true;
                                                            }
                                                        } else {
                                                            if (move.Inventory !== null && move.Inventory !== "") {
                                                                if (move.Inventory.Name !== null && move.Inventory.Name !== "") {
                                                                    inventory.CaseServiceField3 = move.Inventory.Name; // Inventory Name
                                                                    inventory.InventoryName = inventory.CaseServiceField3;
                                                                }
                                                            }
                                                            if (move !== null && move !== "") {
                                                                if (move.PrePackDate !== null && move.PrePackDate !== "") {
                                                                    if (sList.length > 0) {
                                                                        if (sList[0].PrePackDate !== undefined && sList[0].PrePackDate !== null && sList[0].PrePackDate !== "") {
                                                                            RPlanSList.prepackDate = sList[0].PrePackDate;
                                                                        } else {
                                                                            RPlanSList.prepackDate = move.PrePackDate;
                                                                        }
                                                                    } else {
                                                                        RPlanSList.prepackDate = move.PrePackDate;
                                                                    }
                                                                } else {
                                                                    if (sList.length > 0) {
                                                                        if (sList[0].PrePackDate !== null && sList[0].PrePackDate !== "") {
                                                                            RPlanSList.prepackDate = sList[0].PrePackDate;
                                                                        } else {
                                                                            RPlanSList.prepackDate = move.PreferredUpliftDate;
                                                                        }
                                                                    } else {
                                                                        RPlanSList.prepackDate = move.PreferredUpliftDate;
                                                                    }
                                                                }
                                                            }
                                                            // eject IsAddReport
                                                            const crurrebtDate = new Date();
                                                            if (moment(inventory.PrePackDate).format('MM/DD/YYYY') <= crurrebtDate.toLocaleDateString()) {
                                                                RPlanSList.IsAddReport = true;
                                                            }

                                                            if (move.UpliftProperties[0].PropertyAddress !== null && move.UpliftProperties[0].PropertyAddress !== "") {

                                                                if (move.UpliftProperties[0].PropertyAddress.StreetAddressCity !== null && move.UpliftProperties[0].PropertyAddress.StreetAddressCity !== "") {
                                                                    RPlanSList.FromAddress = move.UpliftProperties[0].PropertyAddress.StreetAddressCity;
                                                                }
                                                            }
                                                            if (move.DeliveryProperties[0].PropertyAddress !== null && move.DeliveryProperties[0].PropertyAddress !== "") {

                                                                if (move.DeliveryProperties[0].PropertyAddress.StreetAddressCity !== null && move.DeliveryProperties[0].PropertyAddress.StreetAddressCity !== "") {
                                                                    RPlanSList.ToAddress = move.DeliveryProperties[0].PropertyAddress.StreetAddressCity;
                                                                }
                                                            }
                                                        }

                                                        inventory.RelocationPlanServiceList = RPlanSList;
                                                        //FromAddress
                                                        if (i.FromAddress !== null && i.FromAddress !== "") {
                                                            const formAddress = i.FromAddress;
                                                            if (formAddress.AddressId !== null && formAddress.AddressId !== "")
                                                                inventory.FromAddress.AddressId = formAddress.AddressId;
                                                            if (formAddress.AddressLine1 !== null && formAddress.AddressLine1 !== "") {
                                                                inventory.FromAddress.AddressLine1 = formAddress.AddressLine1;
                                                                inventory.FromAddress.Address = inventory.FromAddress.AddressLine1;
                                                            }
                                                            if (formAddress.AddressLine2 !== null && formAddress.AddressLine2 !== "") {
                                                                inventory.FromAddress.AddressLine2 = formAddress.AddressLine2;
                                                                inventory.FromAddress.Address += " " + inventory.FromAddress.AddressLine2;
                                                            }

                                                            if (formAddress.Suburb !== null && formAddress.Suburb !== "") {
                                                                inventory.FromAddress.Suburb = formAddress.Suburb;
                                                                inventory.FromAddress.Address += " " + inventory.FromAddress.Suburb;
                                                            }
                                                            if (formAddress.State !== null && formAddress.State !== "") {
                                                                inventory.FromAddress.State = formAddress.State;
                                                                //  inventory.FromAddress.Address += " " + inventory.FromAddress.State;
                                                            }
                                                            if (formAddress.PostCode !== null && formAddress.PostCode !== "") {
                                                                inventory.FromAddress.PostCode = formAddress.PostCode;
                                                                inventory.FromAddress.Address += " " + inventory.FromAddress.PostCode;
                                                            }
                                                            if (formAddress.Latitude !== null && formAddress.Latitude !== "")
                                                                inventory.FromAddress.Latitude = formAddress.Latitude;
                                                            if (formAddress.Longitude !== null && formAddress.Longitude !== "")
                                                                inventory.FromAddress.Longitude = formAddress.Longitude;
                                                            if (formAddress.Country !== null && formAddress.Country !== "")
                                                                inventory.FromAddress.Country = formAddress.Country;
                                                            if (formAddress.ConcurrencyCheck !== null && formAddress.ConcurrencyCheck !== "")
                                                                inventory.FromAddress.ConcurrencyCheck = formAddress.ConcurrencyCheck;
                                                        }

                                                        // ToAddress
                                                        if (i.ToAddress !== null && i.ToAddress !== undefined && i.ToAddress !== "") {
                                                            const toAddress = i.ToAddress;
                                                            if (toAddress.AddressId !== null && toAddress.AddressId !== "")
                                                                inventory.ToAddress.AddressId = toAddress.AddressId;
                                                            if (toAddress.AddressLine1 !== undefined && toAddress.AddressLine1 !== null && toAddress.AddressLine1 !== "") {
                                                                inventory.ToAddress.AddressLine1 = toAddress.AddressLine1;
                                                                inventory.ToAddress.Address = inventory.ToAddress.AddressLine1;
                                                            }
                                                            if (toAddress.AddressLine2 !== undefined && toAddress.AddressLine2 !== null && toAddress.AddressLine2 !== "") {
                                                                inventory.ToAddress.AddressLine2 = toAddress.AddressLine2;
                                                                inventory.ToAddress.Address += " " + inventory.ToAddress.AddressLine2;
                                                            }
                                                            if (inventory.ToAddress.Address === undefined) {
                                                                inventory.ToAddress.Address = "";
                                                            }

                                                            if (toAddress.Suburb !== null && toAddress.Suburb !== "") {
                                                                inventory.ToAddress.Suburb = toAddress.Suburb;
                                                                inventory.ToAddress.Address += " " + inventory.ToAddress.Suburb;
                                                            }
                                                            if (toAddress.State !== null && toAddress.State !== "") {
                                                                inventory.ToAddress.State = toAddress.State;
                                                                inventory.ToAddress.Address += " " + inventory.ToAddress.State;
                                                            }
                                                            if (toAddress.PostCode !== null && toAddress.PostCode !== "") {
                                                                inventory.ToAddress.PostCode = toAddress.PostCode;
                                                                inventory.ToAddress.Address += " " + inventory.ToAddress.PostCode;
                                                            }


                                                            if (toAddress.Latitude !== null && toAddress.Latitude !== "")
                                                                inventory.ToAddress.Latitude = toAddress.Latitude;
                                                            if (toAddress.Longitude !== null && toAddress.Longitude !== "")
                                                                inventory.ToAddress.Longitude = toAddress.Longitude;
                                                            if (toAddress.Country !== null && toAddress.Country !== "")
                                                                inventory.ToAddress.Country = toAddress.Country;
                                                            if (toAddress.ConcurrencyCheck !== null && toAddress.ConcurrencyCheck !== "")
                                                                inventory.ToAddress.ConcurrencyCheck = toAddress.ConcurrencyCheck;
                                                        }

                                                        caseDetail.RelocationPlan.Inventories.push(inventory);
                                                        count2++;
                                                        if (a.RelocationPlan.Inventories.length === count2) {
                                                            count3++;
                                                            if (caseDetail.CaseStatusId === 1 || caseDetail.CaseStatusId === 2) {
                                                                currentCaseList.push(caseDetail);
                                                            } else {
                                                                pastCaseList.push(caseDetail);
                                                            }
                                                        }
                                                        if (count1 === count3 && count1 === response.Cases.length) {
                                                            dispatch(getPastCaseList(pastCaseList));
                                                            dispatch(getCurrentCaseList(currentCaseList));
                                                            if (currentCaseList.length > 0) {
                                                                currentCaseList.sort((a, b) => {
                                                                    return a.CaseId - b.CaseId
                                                                });
                                                                let activeCaseID = 0;
                                                                let Id = '';
                                                                const url = `/api/WorkflowService/RetrieveCasePathway`;
                                                                if (id !== null && id !== "" && id !== "1") {
                                                                    Id = { "Id": parseInt(id) }
                                                                    activeCaseID = parseInt(id);
                                                                } else {
                                                                    if (currentCaseList.length !== 0) {
                                                                        Id = { "Id": currentCaseList[0].CaseId };
                                                                        activeCaseID = currentCaseList[0].CaseId;
                                                                        sessionStorage.setItem("RelocationPlanId", currentCaseList[0].RelocationPlan.RelocationPlanId);
                                                                        sessionStorage.setItem("CaseNumber", currentCaseList[0].CaseNumber);
                                                                        sessionStorage.setItem("CaseId", activeCaseID);
                                                                    }
                                                                }
                                                                dispatch(getActiveCaseId(activeCaseID));
                                                                if (activeCaseID !== 0) {
                                                                    api.request(url, 'post', Id).then(response => {
                                                                        dispatch(getWorkFlowCaseDetails(response));
                                                                        if (response.WorkflowCase !== null && response.WorkflowCase !== "") {
                                                                            for (let i = 0; i < response.WorkflowCase.WorkflowCaseStages.length; i++) {
                                                                                if (response.WorkflowCase.WorkflowCaseStages[i].StageName.trim().toLowerCase() === "relocation request" && response.WorkflowCase.WorkflowCaseStages[i].StageStatus === "Completed") {
                                                                                    dispatch(getActiveStageName("MPL"));
                                                                                    return false;
                                                                                } else if (response.WorkflowCase.WorkflowCaseStages[i].StageStatus === "Executing" && response.WorkflowCase.WorkflowCaseStages[i].StageStatus !== null && response.WorkflowCase.WorkflowCaseStages[i].StageStatus !== "") {
                                                                                    dispatch(getActiveStageName(response.WorkflowCase.WorkflowCaseStages[i].StageName));
                                                                                    return false;
                                                                                } else {
                                                                                    dispatch(getActiveStageName("Initiate Case"));
                                                                                }
                                                                            }
                                                                            // response.WorkflowCase.WorkflowCaseStages.forEach(w => {
                                                                            //     //
                                                                            //     if (w.StageName.trim().toLowerCase() === "relocation request" && w.StageStatus === "Completed") {
                                                                            //         dispatch(getActiveStageName("MPL"));
                                                                            //         break ;
                                                                            //     }
                                                                            //     if ( w.StageStatus === "Executing" || w.StageStatus !== null && w.StageStatus !== "") {
                                                                            //         dispatch(getActiveStageName(w.StageName));
                                                                            //         break ;
                                                                            //     }
                                                                            // });
                                                                        } else {
                                                                            dispatch(getActiveStageName("Initiate Case"));
                                                                        }

                                                                    }, err => {
                                                                    })
                                                                }
                                                            } else { // dispatch [Initiate Case] for active state if no current case exists
                                                                dispatch(getActiveStageName("Initiate Case"));
                                                            }
                                                        }
                                                    });
                                                }
                                            }


                                        }

                                    });
                                })

                            }
                            if (a.RelocationPlan.Inventories.length === count2) {
                                count3++;
                            }
                            if (a.RelocationPlan.Inventories.length === 0) {
                                if (caseDetail.CaseStatusId === 1 || caseDetail.CaseStatusId === 2) {
                                    currentCaseList.push(caseDetail);
                                } else {
                                    pastCaseList.push(caseDetail);
                                }
                            }
                        }
                        count1++;
                    });
                    if (count1 === count3 && count1 === response.Cases.length) {
                        dispatch(getPastCaseList(pastCaseList));
                        dispatch(getCurrentCaseList(currentCaseList));
                        if (currentCaseList.length > 0) {
                            currentCaseList.sort((a, b) => {
                                return a.CaseId - b.CaseId
                            });
                            let activeCaseID = 0;
                            let Id = '';
                            const url = `/api/WorkflowService/RetrieveCasePathway`;
                            if (id !== null && id !== "" && id !== "1") {
                                Id = { "Id": parseInt(id) }
                                activeCaseID = parseInt(id);
                            } else {
                                if (currentCaseList.length !== 0) {
                                    Id = { "Id": currentCaseList[0].CaseId };
                                    activeCaseID = currentCaseList[0].CaseId;
                                    sessionStorage.setItem("RelocationPlanId", currentCaseList[0].RelocationPlan.RelocationPlanId);
                                    sessionStorage.setItem("CaseNumber", currentCaseList[0].CaseNumber);
                                    sessionStorage.setItem("CaseId", activeCaseID);
                                }
                            }
                            dispatch(getActiveCaseId(activeCaseID));
                            if (activeCaseID !== 0) {
                                api.request(url, 'post', Id).then(response => {
                                    dispatch(getWorkFlowCaseDetails(response));
                                    if (response.WorkflowCase !== null && response.WorkflowCase !== "") {
                                        for (let i = 0; i < response.WorkflowCase.WorkflowCaseStages.length; i++) {
                                            if (response.WorkflowCase.WorkflowCaseStages[i].StageName.trim().toLowerCase() === "relocation request" && response.WorkflowCase.WorkflowCaseStages[i].StageStatus === "Completed") {
                                                dispatch(getActiveStageName("MPL"));
                                                return false;
                                            } else if (response.WorkflowCase.WorkflowCaseStages[i].StageStatus === "Executing" && response.WorkflowCase.WorkflowCaseStages[i].StageStatus !== null && response.WorkflowCase.WorkflowCaseStages[i].StageStatus !== "") {
                                                dispatch(getActiveStageName(response.WorkflowCase.WorkflowCaseStages[i].StageName));
                                                return false;
                                            } else {
                                                dispatch(getActiveStageName("Initiate Case"));
                                            }
                                        }
                                    } else {
                                        dispatch(getActiveStageName("Initiate Case"));
                                    }

                                }, err => {
                                })
                            }
                        } else { // dispatch [Initiate Case] for active state if no current case exists
                            dispatch(getActiveStageName("Initiate Case"));
                        }
                    }
                } else {
                    dispatch(getActiveStageName("Initiate Case"));
                }
            }

        }).then(() => {
            // dispatch(setLoading(false));
        })
    }
}

// fetches individual inventory's rooms
export function fetchInventoryRooms(inventoryID) {
    const url = `/api/InventoryDetailService/RetrieveInventoryRooms`;
    const InventoryID = { "Id": inventoryID };
    return api.request(url, 'post', InventoryID)
        .then(response => {
            return response.InventoryRooms
        })
}

// update invidual inventory room
export function updateInventoryRooms(inventoryID, inventoryRooms) {
    const InventoryID = { "Id": inventoryID };
    const updatedInventoryRooms = { ...inventoryRooms }
    return dispatch => {
        fetchInventoryRooms(inventoryID)
            .then(inventoryRooms => {
                updatedInventoryRooms[InventoryID] = inventoryRooms;
                dispatch(getInventoryRooms(updatedInventoryRooms));
            });
    }
}

// get the particular inventory room details
export function retrieveInventoryRoom(inventoryId, roomId, isRetrieveVehicles) {
    const url = `api/InventoryDetailService/RetrieveInventoryRoom`;
    const query = {
        InventoryId: inventoryId,
        Id: roomId,
        IsRetrieveVehicles: isRetrieveVehicles
    }

    return dispatch => {
        return api.request(url, 'post', query)
            .then(response => {
                dispatch(saveNewRoom(response.InventoryRoom));
                dispatch(setLoading(false));
                if (isRetrieveVehicles) {
                    dispatch(updateInventoryList(response.InventoryRoom));
                }
                return response.InventoryRoom
            })
            .catch(error => error)
    }
}

export function getRetrieveUnUsedInventoryDetailsByPartyId(transfereeId) {
    const url = `/api/InventoryDetailService/RetrieveUnUsedInventoryDetailsByPartyId`;
    const urlR = `/api/InventoryDetailService/RetrieveInventoryRooms`;
    const urlD = `/api/InventoryDetailService/RetrieveInventoryRoom`;
    const id = { "Id": transfereeId }

    return dispatch => {
        return api.request(url, 'post', id).then(response => {
            let InventoryList = [];
            let roomDetails = '';
            const inventoryRooms = {};

            if (response.UnusedInventories.length > 0) {
                response.UnusedInventories.forEach(i => {
                    let unusedI = {};
                    unusedI.Vehicles = [];
                    unusedI.constID = i.InventoryID;
                    unusedI.Name = i.Name;
                    unusedI.Amount = i.Amount;
                    unusedI.Volume = i.Volume;
                    unusedI.InventoryID = i.InventoryID;
                    const InventoryID = { "Id": i.InventoryID };
                    api.request(urlR, 'post', InventoryID).then(response => {
                        // add inventory rooms to object
                        inventoryRooms[i.InventoryID] = response.InventoryRooms;
                        dispatch(getInventoryRooms(inventoryRooms));
                        if (response.InventoryRooms !== null && response.InventoryRooms !== "" && response.InventoryRooms.length > 0) {
                            response.InventoryRooms.forEach(r => {
                                if (r.Name.trim() === "Vehicles") {
                                    if (r.InventoryRoomID !== null && r.InventoryRoomID !== "") {
                                        const roomIDAndInvId = { "InventoryId": i.InventoryID, "Id": r.InventoryRoomID, "IsRetrieveVehicles": true };
                                        api.request(urlD, 'post', roomIDAndInvId).then(response => {
                                            roomDetails = response.InventoryRoom;
                                            unusedI.RoomDetails = roomDetails;

                                            // find the inventoryRoom in inventoryRooms[i.InventoryID]
                                            // find the index of the vehicle object
                                            const vehicleIndex = inventoryRooms[i.InventoryID].findIndex(inventoryRoom =>
                                                inventoryRoom.InventoryRoomID === roomDetails.InventoryRoomID);

                                            (inventoryRooms[i.InventoryID])[vehicleIndex] = roomDetails;

                                            if (roomDetails.InventoryInventoryGroups !== undefined && roomDetails.InventoryInventoryGroups !== "" && roomDetails.InventoryInventoryGroups.length > 0) {
                                                roomDetails.InventoryInventoryGroups.forEach(g => {
                                                    if (g.Vehicles !== null && g.Vehicles !== "") {
                                                        let inventoryVehicle = {};

                                                        inventoryVehicle.VehiclePartyAssetID = Number(g.Vehicles.VehiclePartyAssetID.toString());
                                                        if (g.Vehicles.VehicleName !== null && g.Vehicles.VehicleName.toString() !== "")
                                                            inventoryVehicle.MakeAndModel = g.Vehicles.VehicleName.toString();

                                                        if (g.ModifiedDate !== null && g.ModifiedDate.toString() !== "") {
                                                            inventoryVehicle.VehicleModifiedDate = g.ModifiedDate.toString();
                                                        }

                                                        if (g.Vehicles.VehicleTypeID !== null && g.Vehicles.VehicleTypeID.toString() !== "")
                                                            inventoryVehicle.VehicleTypeID = g.Vehicles.VehicleTypeID.toString()
                                                        unusedI.Vehicles.push(inventoryVehicle);
                                                    }
                                                });
                                            }
                                        });
                                    }
                                }
                            });
                        }
                    });
                    InventoryList.push(unusedI);
                });
                dispatch(getInventoryList(InventoryList));
            }
        });
    }
}